// extracted by mini-css-extract-plugin
export default {"root":"owner-selector_root__WJQs2","addButton":"owner-selector_addButton__Z9R2k","popup":"owner-selector_popup__xC8Ev"};